'use strict';

export default function(milliseconds, fn) {
  setTimeout(fn, milliseconds);
}
